import React, { useEffect } from "react";
import styles from "./Modal.module.scss";
import { XmarkIcon } from "../../assets/icons/XmarkIcon";

export const Modal = ({ visible, handleClose, children }) => {
  useEffect(() => {
    if (visible) {
      // Блокируем прокрутку
      document.body.style.overflow = "hidden";
    } else {
      // Восстанавливаем прокрутку
      document.body.style.overflow = "";
    }

    // Убираем стиль при размонтировании
    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  return (
    <div className={`${visible ? styles.modalOverlay : styles.displayNone}`}>
      <div className={styles.modal}>
        <div className={styles.closeModal} onClick={handleClose}>
          <XmarkIcon width={13} height={20} fill={"white"} />
        </div>
        {children}
      </div>
    </div>
  );
};
